import React from "react";
import loadable from "@loadable/component";

const ContentLoaderFunction = () => {
    return <div>Loading...</div>;
};
export default loadable(
    () =>
        import(
            /* webpackChunkName: 'scholarshipRedirectionLayer' */ "./ScholarshipRedirectionLayer"
        ),
    {
        fallback: <ContentLoaderFunction />,
    },
);
